import React from 'react';
import { DetailsPane } from '../types';

const Appended = ({
    activeTab,
    activeTabTotal,
    firstTab,
    secondTab,
}: {
    activeTab: string;
    activeTabTotal?: number;
    firstTab?: DetailsPane;
    secondTab?: DetailsPane;
}) => {
    const FirstAppended = firstTab?.appended ? firstTab?.appended : () => null;
    const SecondAppended = secondTab?.appended
        ? secondTab?.appended
        : () => null;

    const isFirstTab = activeTab === firstTab?.name;
    const isSecondTab = activeTab === secondTab?.name;

    if (!activeTabTotal) {
        return null;
    }

    return (
        <>
            {isFirstTab && <FirstAppended />}
            {isSecondTab && <SecondAppended />}
        </>
    );
};

export default Appended;
